import { MenuItemType } from '@/layouts/private/topBar/components/sideBarMenu/model/SideBarMenuItems.model.tsx';

export type MenuTranslation = Record<MenuItemType, string>;

export const menuTranslation: MenuTranslation = {
  analysisRemarks: 'Analysis Remarks',
  experienceCompanies: 'Experience Companies',
  interviewSimulation: 'Interview Simulation',
  meetings: 'Meetings',
  processes: 'Processes',
  processTemplates: 'Process Templates',
  statistics: 'Statistics',
};
